import { render, staticRenderFns } from "./vouchers.vue?vue&type=template&id=baa421ba&scoped=true"
import script from "./vouchers.vue?vue&type=script&lang=js"
export * from "./vouchers.vue?vue&type=script&lang=js"
import style0 from "./vouchers.vue?vue&type=style&index=0&id=baa421ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa421ba",
  null
  
)

export default component.exports